import React from 'react';

import Button from 'react-bootstrap/Button';
import {Col, Row, Image, InputGroup, Form, Container, Card} from "react-bootstrap";
import EmailForm from "../../common/EmailForm";
import DownloadButton from '../../common/DownloadButton';

function Footer() {

    return (
        <Container style={{marginTop: 100, padding: 20, marginBottom: 100}}>
            <Row className={'justify-content-center'}>
                <Col sm={12} md={12} lg={6}>
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <DownloadButton/>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default Footer;
